module.exports = __webpack_public_path__ + "img/ExitIcon.11200d20.svg";